import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer";
import Navbar from "../../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { apiGet, apiPost } from "../../../API/Api_Url";
import { FaTimes } from "react-icons/fa";

function UserAddFreelancerJobPost() {
    const navigate = useNavigate();
    const [IsUploading, setIsUploading] = useState(false);
    const [Requirements, setRequirements] = useState([]);
    const [IsLoading, setIsLoading] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [errors, setErrors] = useState({});


    // form states
    const [UserRequirement, setUserRequirement] = useState("");
    const [Title, setTitle] = useState("");
    const [Description, setDescription] = useState("");
    const [Skillsrequire, setSkillsrequire] = useState([]);
    const [skillInput, setSkillInput] = useState("");
    const [Address, setAddress] = useState("");
    const [City, setCity] = useState("");
    const [State, setState] = useState("");
    const [Budget, setBudget] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    // fetch all user requirements
    const GetUserAllInRequirements = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet(
                "api/user/GetAllUserInConstructionConstructionRequirement"
            );
            setRequirements(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        GetUserAllInRequirements();
    }, []);

    const handleAddSkill = () => {
        if (skillInput.trim() && !Skillsrequire.includes(skillInput.trim())) {
            setSkillsrequire([...Skillsrequire, skillInput.trim()]);
        }
        setSkillInput("");
    };

    const handleRemoveSkill = (skill) => {
        setSkillsrequire(Skillsrequire.filter((s) => s !== skill));
    };

    const handleUploadRequirement = async () => {
        let newErrors = {};

        if (!UserRequirement.trim())
            newErrors.UserRequirement = "Requirement is required";
        if (!Title.trim()) newErrors.Title = "Title is required";
        if (!Description.trim()) newErrors.Description = "Description is required";
        if (Skillsrequire.length === 0) newErrors.Skillsrequire = "Skills are required";
        if (!Address.trim()) newErrors.Address = "Address is required";
        if (!City.trim()) newErrors.City = "City is required";
        if (!State.trim()) newErrors.State = "State is required";
        if (!Budget.trim()) newErrors.Budget = "Budget is required";
        if (!startDate.trim()) newErrors.startDate = "Start date is required";
        if (!endDate.trim()) newErrors.endDate = "End date is required";

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        const payload = {
            UserRequirement,
            Title,
            Description,
            Skillsrequire: Skillsrequire,
            location: {
                Address,
                City,
                State,
            },
            Budget,
            timeline: {
                startDate,
                endDate,
            },
        };

        try {
            setIsLoading(true);
            const response = await apiPost(
                "/api/user/UsercreateFreelancerJobPost",
                payload
            );
            if (response?.data) {
                toast.success(
                    response?.data?.message ||
                    response?.message ||
                    "Job post created successfully!"
                );
                setUserRequirement("");
                setTitle("");
                setDescription("");
                setSkillsrequire("");
                setAddress("");
                setCity("");
                setState("");
                setBudget("");
                setStartDate("");
                setEndDate("");
                setShowConfirmation(true);

                setShowConfirmation(true);
                const timer = setTimeout(() => {
                    navigate("/");
                }, 3000);
                
                return () => clearTimeout(timer);
            } else {
                toast.error(response?.message || "Failed to create job post");
            }
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const selectRequirement = (id) => {
        const selectedReq = Requirements.find((req) => req._id === id);
        if (selectedReq) {
            setUserRequirement(selectedReq._id);
            setAddress(selectedReq?.Location?.Address || "");
            setCity(selectedReq?.City || "");
            setState(selectedReq?.State || "");
        }
    };

    return (
        <>
            <Navbar />
            <div className="w-full mx-auto pt-[10%]">
                {showConfirmation ? (
                    <div className="pt-[3%] pb-[5%]">
                        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
                            <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50 text-center p-6">
                                <h2 className="text-4xl font-bold text-green-600 mb-4">
                                    🎉 Your job post is live!
                                </h2>
                                <p className="text-2xl text-gray-800">
                                    Freelancer Engineers will connect with you soon.
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="pt-[3%] pb-[5%]">
                        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                                Add Freelancer Job Post
                            </h2>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-5">
                                <div>
                                    <label className="block mb-1 font-medium">
                                        Select Requirement<span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`form-input w-full ${errors?.UserRequirement ? "border-red-500" : ""
                                            }`}
                                        value={UserRequirement}
                                        onChange={(e) => selectRequirement(e.target.value)}
                                    >
                                        <option value="">Select Requirement</option>
                                        {Requirements?.map((req) => (
                                            <option key={req?._id} value={req?._id}>
                                                {req?.ProjectType} ({req?.SizeDimension?.Area})
                                            </option>
                                        ))}
                                    </select>
                                    {errors?.UserRequirement && (
                                        <p className="text-red-500 text-sm mt-1">
                                            {errors?.UserRequirement}
                                        </p>
                                    )}
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Title<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className={`form-input w-full ${errors?.Title ? "border-red-500" : ""
                                            }`}
                                        type="text"
                                        placeholder="Enter Title"
                                        value={Title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                    {errors?.Title && (
                                        <p className="text-red-500 text-sm mt-1">{errors?.Title}</p>
                                    )}
                                </div>

                                <div className="md:col-span-2">
                                    <label className="block mb-1 font-medium">
                                        Description<span className="text-red-500">*</span>
                                    </label>
                                    <textarea
                                        className={`form-input w-full ${errors?.Description ? "border-red-500" : ""
                                            }`}
                                        placeholder="Enter Description"
                                        value={Description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                    {errors?.Description && (
                                        <p className="text-red-500 text-sm mt-1">
                                            {errors?.Description}
                                        </p>
                                    )}
                                </div>
                                <div className="md:col-span-2">
                                    <label className="block mb-1 font-medium">
                                        Skills<span className="text-red-500">*</span>
                                    </label>
                                    <div className="flex gap-2 mb-2">
                                        <input
                                            className="form-input flex-1"
                                            type="text"
                                            placeholder="e.g. Structural Design"
                                            value={skillInput}
                                            onChange={(e) => setSkillInput(e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), handleAddSkill())}
                                        />
                                        <button
                                            type="button"
                                            onClick={handleAddSkill}
                                            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                                        >
                                            Add
                                        </button>
                                    </div>

                                    <div className="flex flex-wrap gap-2">
                                        {Skillsrequire?.map((skill, idx) => (
                                            <span
                                                key={idx}
                                                className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full flex items-center gap-2 text-sm"
                                            >
                                                {skill}
                                                <FaTimes
                                                    className="cursor-pointer hover:text-red-500"
                                                    onClick={() => handleRemoveSkill(skill)}
                                                />
                                            </span>
                                        ))}
                                    </div>

                                    {errors?.Skillsrequire && (
                                        <p className="text-red-500 text-sm mt-1">{errors?.Skillsrequire}</p>
                                    )}
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Address<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className={`form-input w-full ${errors?.Address ? "border-red-500" : ""
                                            }`}
                                        type="text"
                                        placeholder="Enter Address"
                                        value={Address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                    {errors?.Address && (
                                        <p className="text-red-500 text-sm mt-1">
                                            {errors?.Address}
                                        </p>
                                    )}
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        City<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className={`form-input w-full ${errors?.City ? "border-red-500" : ""
                                            }`}
                                        type="text"
                                        placeholder="Enter City"
                                        value={City}
                                        onChange={(e) => setCity(e.target.value)}
                                    />
                                    {errors?.City && (
                                        <p className="text-red-500 text-sm mt-1">{errors?.City}</p>
                                    )}
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        State<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className={`form-input w-full ${errors?.State ? "border-red-500" : ""
                                            }`}
                                        type="text"
                                        placeholder="Enter State"
                                        value={State}
                                        onChange={(e) => setState(e.target.value)}
                                    />
                                    {errors?.State && (
                                        <p className="text-red-500 text-sm mt-1">{errors?.State}</p>
                                    )}
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Budget<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className={`form-input w-full no-spinner ${errors?.Budget ? "border-red-500" : ""}`}
                                        type="number"
                                        placeholder="Enter Budget"
                                        value={Budget}
                                        onChange={(e) => setBudget(e.target.value)}
                                    />
                                    {errors?.Budget && (
                                        <p className="text-red-500 text-sm mt-1">{errors?.Budget}</p>
                                    )}
                                </div>


                                <div>
                                    <label className="block mb-1 font-medium">
                                        Start Date<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className={`form-input w-full ${errors?.startDate ? "border-red-500" : ""
                                            }`}
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                    {errors?.startDate && (
                                        <p className="text-red-500 text-sm mt-1">
                                            {errors?.startDate}
                                        </p>
                                    )}
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        End Date<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className={`form-input w-full ${errors?.endDate ? "border-red-500" : ""
                                            }`}
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                    {errors?.endDate && (
                                        <p className="text-red-500 text-sm mt-1">{errors?.endDate}</p>
                                    )}
                                </div>
                            </div>

                            <button
                                onClick={handleUploadRequirement}
                                disabled={IsLoading}
                                className={`w-full mt-8 text-white py-3 rounded-full font-medium transition 
                                    ${IsLoading
                                        ? "bg-gray-400 cursor-not-allowed"
                                        : "bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90"
                                    }`}
                            >
                                {IsLoading ? (
                                    <div className="flex items-center justify-center">
                                        <svg
                                            className="animate-spin h-5 w-5 text-white mr-2"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"
                                            ></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                            ></path>
                                        </svg>
                                        Loading...
                                    </div>
                                ) : (
                                    "Submit"
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </>
    );
}

export default UserAddFreelancerJobPost;
